import styled, { css } from 'styled-components'
import { mq } from '../../styles/vars/media-queries.style'
import { easings } from '../../styles/vars/easings.style'

export const FullWidthCarouselWrapper = styled.div``

export const FullWidthCarouselMain = styled.div`
  -webkit-tap-highlight-color: transparent;
`

export const FullWidthCarouselHeader = styled.div`
  pointer-events: none;
  position: relative;
  z-index: 2;
`

export const FullWidthCarouselContainer = styled.div`
  overflow: hidden;
  position: relative;
  z-index: 1;
`

export const FullWidthCarouselHeading = styled.div`
  pointer-events: all;
  text-align: center;
`

export const FullWidthCarouselTrack = styled.div`
  border-radius: 0.6rem;
  height: 70vw;
  max-height: 100rem;
  overflow: hidden;
  position: relative;
  width: 100%;

  ${mq.tabletL} {
    height: 50vw;
  }
`

const carouselTextWrap = css`
  list-style-type: none;
  position: relative;
`

const carouselTextItem = css`
  left: 0;
  opacity: ${props => (props.active ? 1 : 0)};
  position: absolute;
  top: 0;
  transition: opacity 1s ${easings.inOut.quart};
  width: 100%;

  &:first-child {
    position: relative;
  }
`

export const FullWidthCarouselTitles = styled.ul`
  ${carouselTextWrap}
`

export const FullWidthCarouselTitle = styled.li`
  ${carouselTextItem}
`

export const FullWidthCarouselDetails = styled.ul`
  ${carouselTextWrap}
  min-height: ${props => `${props.minH}px`};
`

export const FullWidthCarouselDetail = styled.li`
  ${carouselTextItem}
`
